import { PackagingButtonDownloadFile } from './ButtonDownloadFile';

export const ButtonDownloadFile = PackagingButtonDownloadFile;
